export const __normalizeDiscounts = (discountsObject) => {
    const globalDiscountData = discountsObject?.product?.globalDiscount || null
    const bulkDiscountsData = discountsObject?.product?.bulkDiscounts || null
    const loyaltyDiscountData =
        discountsObject?.product?.loyaltyDiscount || null

    const campaignDiscountData =
        discountsObject?.storefront?.campaignDiscount || null
    const orderDiscountData =
        discountsObject?.storefront?.orderDiscounts || null

    const globalDiscount = {}
    const bulkDiscounts = {}
    const campaignDiscount = {}
    const loyaltyDiscount = {}
    const orderDiscount = {}

    if (globalDiscountData?.percentage) {
        globalDiscount[globalDiscountData.percentage] = globalDiscountData
    }

    if (bulkDiscountsData) {
        bulkDiscountsData?.map((item) => {
            bulkDiscounts[item.percentage] = {
                isBulkDiscount: true,
                ...item,
            }
        })
    }

    if (orderDiscountData && orderDiscountData?.length) {
        orderDiscountData?.map((item) => {
            orderDiscount[item.percentage] = {
                isOrderDiscount: true,
                ...item,
            }
        })
    }

    if (campaignDiscountData) {
        campaignDiscount[campaignDiscountData.percentage] = campaignDiscountData
    }

    if (loyaltyDiscountData) {
        loyaltyDiscount[loyaltyDiscountData.percentage] = loyaltyDiscountData
    }

    return {
        globalDiscount,
        bulkDiscounts,
        campaignDiscount,
        loyaltyDiscount,
        orderDiscount,
    }
}
